import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import VueSession from 'vue-session';
import vuetify from '@/plugins/vuetify';
import Dialog from '@/plugins/dialog';
import I18n from '@/plugins/i18n';
import I18nData from '@/common/bundle';
import { routes } from '@/common/routes';
import './assets/css/style.css';
import '@mdi/font/css/materialdesignicons.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import axios from "axios";

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(VueSession);
Vue.use(I18n, { data: I18nData });
Vue.use(Dialog, {}, vuetify);

const vm = new Vue({
  router: new VueRouter({
    mode: 'hash',
    routes,
  }),
  vuetify,
  render: h => h(App),
});

axios
  .get(`/l-api/get-user`)
  .then((res) => {
    if (res.status === 200) {
      const user = res.data.user;
      vm.$session.set("user_id", user.user_id);
      vm.$session.set("course_id", user.course_id);
      vm.$session.set("role", user.role);
      vm.$session.set("year", user.year);
      vm.$session.set("semester", user.semester);
      vm.$session.set("loaded-done", false);

      vm.$mount('#app');
    }
  });

